import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import  { useFetchShareHouse } from '../../hooks/useFetchData';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css'; // LeafletのCSSをインポート
import MainLayout from '../../components/layouts/MainLayout';
import Breadcrumb from '../../components/shared/Breadcrumbs';

const Map = () => {
  const { data: sharehouses, loading, error } = useFetchShareHouse(); 
  const breadcrumbs = [
    { label: "Home", path: "/" },
    { label: "シェアハウス一覧", path: "/sharehouse" },
    { label: "マップ検索", path: "/sharehouse/map" },
  ];

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error loading jobs: {error.message}</p>;

  const positions = sharehouses.map((sharehouse_past) => ({
    id: sharehouse_past.id,
    title: sharehouse_past.title,
    rent: sharehouse_past.rent,
    lat: sharehouse_past.latitude,
    lng: sharehouse_past.longitude,
    img: sharehouse_past.images[0].image,
    available: sharehouse_past.available,
  }));

  // const positions = [
  //   { id: 1, lat: -28.0303534, lng: 153.3884451 }, // ゴールドコーストの中心
  //   { id: 2, lat: -28.0324, lng: 153.4266 }, // サウスポート近辺
  //   { id: 3, lat: -28.0227, lng: 153.3603 }  // サーファーズパラダイス近辺
  // ];
  const customIcon = new L.Icon({
    iconUrl: '/media/pin.svg', 
    className: 'custom-icon',
    iconSize: [32, 32], // アイコンのサイズ
    iconAnchor: [16, 32], // アイコンのアンカー位置
    popupAnchor: [0, -32], // ポップアップの位置
  });

  return (
    <MainLayout>
      <Breadcrumb items={breadcrumbs} />
      <div className='sharehouse_map' style={{ height: '75vh' }}>
        <MapContainer center={positions[0]} zoom={13} style={{ width: '100%', height: '100%' }}>
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          
          {/* positions 配列を使ってマーカーを生成 */}
          {positions.map((position) => (
            <Marker 
              key={position.id} 
              position={[position.lat, position.lng]}
              icon={customIcon}
            >
              <Popup>
                <div className='popup'>
                  <div className='popup__img'>
                    <img src={position.img} />
                  </div>
                  <div className='popup__cont'>
                    <span>Rent: {position.rent}</span>
                    <span>{position.available}</span>
                    <a href={`/sharehouse/${position.id}`}>詳細を見る</a>
                  </div>
                </div>
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      </div>
    </MainLayout>
  );
};

export default Map;
